const UserLanguagePreference =
{
    Unknown: 0,
    English: 1,
    Spanish: 2,
    Arabic: 3,
    German: 4,
    Italian: 5,
    French: 6,
    Russian: 7,
    Dutch: 8
}

export default UserLanguagePreference;